import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Header from './components/Header';
import AdultoIdososHeader from './components/AdultoIdososHeader';
import AgeGate, { openAgeGate } from './components/AgeGate';
import Footer from './components/Footer';
import Home from './pages/Home';
import SaudeGeral from './pages/SaudeGeral/HabitosSaudaveis';
import FaleConosco from './pages/FaleConosco';
import PinIcon from '@mui/icons-material/PinDrop';
import CloseIcon from '@mui/icons-material/Close';

//jogos
import JogoDaMemoria from './pages/Jogos/JogoDaMemoria';
import Flashcards from './pages/Jogos/Flashcards';
import VerdadeOuMentira from './pages/Jogos/VerdadeOuMentira';

//Saúde Bucal
import Aparelhos from './pages/SaudeBucal/Aparelhos';
import Clareamentos from './pages/SaudeBucal/Clareamentos';
import Siso from './pages/SaudeBucal/Siso';
import HigienizacaoBucal from './pages/SaudeBucal/HigienizacaoBucal';
import PrincipaisAgravosBucais from './pages/SaudeBucal/PrincipaisAgravosBucais';
import QuemSomos from './pages/QuemSomos';
import HabitosSaudaveis from './pages/SaudeGeral/HabitosSaudaveis';
import SaudeEmocional from './pages/SaudeGeral/SaudeEmocional';
import ComoSerAtendido from './pages/ComoSerAtendido';
import ProblemasNosDiasDeHoje from './pages/SaudeGeral/ProblemasNosDiasDeHoje';
import Button from './components/Button';

// Adulto e Idosos
import AdultoIdososHome from './pages/AdultoIdosos/Home';
import HigienizacaoBucalAdulto from './pages/AdultoIdosos/SaudeBucal/HigienizacaoBucal';
import ProtesesImplantes from './pages/AdultoIdosos/SaudeBucal/ProtesesImplantes';
import AgravosBucaisAdulto from './pages/AdultoIdosos/SaudeBucal/AgravosBucais';
import EnvelhecimentoBucal from './pages/AdultoIdosos/SaudeBucal/EnvelhecimentoBucal';
import SaudeBucalSaudeGeral from './pages/AdultoIdosos/SaudeBucal/SaudeBucalSaudeGeral';
import HabitosSaudaveisAdulto from './pages/AdultoIdosos/SaudeGeral/HabitosSaudaveis';
import SaudeEmocionalAdulto from './pages/AdultoIdosos/SaudeGeral/SaudeEmocional';
import QuizAdultoIdosos from './pages/AdultoIdosos/Atividades/Quiz';
import CenariosSimulacao from './pages/AdultoIdosos/Atividades/CenariosSimulacao';
import MitosVerdades from './pages/AdultoIdosos/Atividades/MitosVerdades';
import MateriaisEducativos from './pages/AdultoIdosos/MateriaisEducativos';
import SaudeGestacao from './pages/AdultoIdosos/SaudeBucal/SaudeGestacao';
import SaudeSexual from './pages/AdultoIdosos/SaudeGeral/SaudeSexual';
import Atendimento from './pages/AdultoIdosos/Atendimento';
import QuemSomosAdulto from './pages/AdultoIdosos/QuemSomos';
import FaleConoscoAdulto from './pages/AdultoIdosos/FaleConosco';
import { AmbientBackground } from './pages/AdultoIdosos/shared';

function AppContent() {
  const location = useLocation();
  const [showModalContato, setShowModalContato] = useState(false);
  const isAdultoIdosos = location.pathname.startsWith('/adulto-idosos');

  return (
    <>
      <AgeGate />
      <button
        type="button"
        onClick={openAgeGate}
        title="Trocar faixa etária"
        style={{
          position: 'fixed',
          bottom: 64,
          left: 20,
          zIndex: 9999,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '8px 14px',
          borderRadius: 30,
          border: 'none',
          cursor: 'pointer',
          background: 'rgba(255, 255, 255, 0.92)',
          color: '#0277BD',
          fontFamily: "'Open Sans', sans-serif",
          fontSize: '0.8rem',
          fontWeight: 700,
          boxShadow: '0 4px 14px rgba(1, 87, 155, 0.25)',
        }}
      >
        🔁 Trocar faixa etária
      </button>
      {isAdultoIdosos && <AmbientBackground />}
      {isAdultoIdosos ? <AdultoIdososHeader /> : <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/higienizacao-bucal" element={<HigienizacaoBucal />} />
        <Route path="/quem-somos" element={<QuemSomos />} />
        <Route path="/principais-agravos-bucais" element={<PrincipaisAgravosBucais />} />
        <Route path="/saude-geral" element={<SaudeGeral />} />
        <Route path="/jogos/jogo-da-memoria" element={<JogoDaMemoria />} />
        <Route path="/jogos/flashcards" element={<Flashcards />} />
        <Route path="/jogos/verdade-ou-mentira" element={<VerdadeOuMentira />} />
        <Route path="/saude-bucal/aparelhos" element={<Aparelhos />} />
        <Route path="/saude-bucal/clareamentos" element={<Clareamentos />} />
        <Route path="/saude-bucal/siso" element={<Siso />} />
        <Route path="/saude-bucal/higienizacao-bucal" element={<HigienizacaoBucal />} />
        <Route path="/saude-bucal/agravos-bucais" element={<PrincipaisAgravosBucais />} />
        <Route path="/fale-conosco" element={<FaleConosco />} />
        <Route path="/saude-geral/habitos-saudaveis" element={<HabitosSaudaveis />} />
        <Route path="/saude-bucal/saude-emocional" element={<SaudeEmocional />} />
        <Route path="/como-ser-atendido" element={<ComoSerAtendido />} />
        <Route path="/saude-geral/problemas-dia-a-dia" element={<ProblemasNosDiasDeHoje />} />

        {/* Adulto e Idosos */}
        <Route path="/adulto-idosos" element={<AdultoIdososHome />} />
        <Route path="/adulto-idosos/saude-bucal/higienizacao-bucal" element={<HigienizacaoBucalAdulto />} />
        <Route path="/adulto-idosos/saude-bucal/proteses-implantes" element={<ProtesesImplantes />} />
        <Route path="/adulto-idosos/saude-bucal/agravos-bucais" element={<AgravosBucaisAdulto />} />
        <Route path="/adulto-idosos/saude-bucal/gestacao" element={<SaudeGestacao />} />
        <Route path="/adulto-idosos/saude-bucal/envelhecimento" element={<EnvelhecimentoBucal />} />
        <Route path="/adulto-idosos/saude-bucal/saude-geral" element={<SaudeBucalSaudeGeral />} />
        <Route path="/adulto-idosos/saude-geral/habitos-saudaveis" element={<HabitosSaudaveisAdulto />} />
        <Route path="/adulto-idosos/saude-geral/saude-emocional" element={<SaudeEmocionalAdulto />} />
        <Route path="/adulto-idosos/saude-geral/saude-sexual" element={<SaudeSexual />} />
        <Route path="/adulto-idosos/atividades/quiz" element={<QuizAdultoIdosos />} />
        <Route path="/adulto-idosos/atividades/cenarios-simulacao" element={<CenariosSimulacao />} />
        <Route path="/adulto-idosos/atividades/mitos-verdades" element={<MitosVerdades />} />
        <Route path="/adulto-idosos/atendimento" element={<Atendimento />} />
        <Route path="/adulto-idosos/quem-somos" element={<QuemSomosAdulto />} />
        <Route path="/adulto-idosos/fale-conosco" element={<FaleConoscoAdulto />} />
        <Route path="/adulto-idosos/materiais-educativos" element={<MateriaisEducativos />} />
      </Routes>
      <div style={{ position: 'fixed', bottom: 0, width: '100%' }}>
        <Footer />
      </div>
      <Dialog
        open={showModalContato}
        onClose={() => setShowModalContato(false)}
      >
        <DialogTitle id="alert-dialog-title">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            Informações de contato
            <Button style={{ color: 'black' }} aria-label="close" onClick={() => setShowModalContato(false)}>
              <CloseIcon fontSize="small" />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div>
            <p>Endereço: Hospital de Odontologia - Bloco 4L Anexo B Térreo, R. República do Piratini, 1229-1101 - Umuarama, Uberlândia - MG, 38405-266 </p><p>Telefone: (34) 3225-8108 </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <iframe style={{ width: '100%', border: 'none' }} src="https://maps.google.com/maps?q=R.+Rep%C3%BAblica+do+Piratini%2C+1229-1101+-+Umuarama%2C+Uberl%C3%A2ndia+-+MG%2C+38405-266&output=embed" title="mapa1"></iframe>
            </div>
            <p>Pronto Socorro Odontológico - 4A - Umuarama, Uberlândia - MG, 38402-293</p><p>Telefone: (34) 3225-8151</p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <iframe style={{ width: '100%', border: 'none' }} src="https://maps.google.com/maps?q=Pronto+Socorro+Odontol%C3%B3gico+-+4A+-+Umuarama&output=embed" title="mapa2"></iframe>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <div style={{
        position: 'fixed',
        bottom: '64px',
        right: '45px',
        zIndex: 9999
      }}>
        <IconButton
          style={{
            backgroundColor: 'rgb(22, 73, 188)',
            color: 'white',
            width: '55px',
            height: '55px'
          }}
          onClick={() => setShowModalContato(true)}
          color="primary" aria-label="info" variant="contained">
          <PinIcon style={{ width: 30, height: 30 }} />
        </IconButton>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
